import React from "react";
import { useRouteMatch, useHistory } from "react-router";

import { Container, Fab, Stack, Tooltip, Typography } from "@mui/material";
import { Plus as CreateIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";

import CreateOrderState from "components/orderState/admin/CreateOrderState";
import OrderStatesList from "components/orderState/admin/OrderStatesList";

export default function OrderStatesPage() {
  const history = useHistory();
  const match = useRouteMatch();

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <CreateOrderState
            onCreate={(orderState) =>
              history.push(`${match.url}/${orderState.id}`)
            }
          >
            {({ open }) => (
              <Tooltip placement="top" title="Créer un êtat de commande">
                <Fab onClick={open} size="small" color="primary">
                  <CreateIcon />
                </Fab>
              </Tooltip>
            )}
          </CreateOrderState>

          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Êtats des commandes
          </Typography>
        </Stack>
      </Layout.Toolbar>

      <OrderStatesList />
    </Container>
  );
}
